import { DropdownEditor, DropdownValueType } from '@approvalmax/ui';
import { PlainDataProvider } from 'modules/data-providers';
import { memo, useCallback, useMemo } from 'react';

import { localClearingSystemKey } from '../../AddBeneficiaryPopup.constants';
import { ClearingSystemListItemData } from '../../AddBeneficiaryPopup.types';
import ClearingSystemListItem from '../ClearingSystemListItem/ClearingSystemListItem';
import { FieldSelectProps } from './FieldSelect.types';

const FieldSelect = memo<FieldSelectProps>((props) => {
    const { field, formValue, setFormValues, setFieldsTouched } = props;

    const items: ClearingSystemListItemData[] = useMemo(() => {
        return (
            field.field?.options?.map((option) => {
                let description = option.description || '';

                if (option.payment_limit) {
                    description += '\n' + option.payment_limit;
                }

                if (option.processing_time) {
                    description += '\n' + option.processing_time;
                }

                return {
                    id: option.value,
                    text: option.label,
                    description,
                };
            }) || []
        );
    }, [field.field?.options]);

    const selectedItem = useMemo(() => items.find((item) => item.id === formValue) || null, [formValue, items]);

    const handleChange = useCallback(
        (value: DropdownValueType) => {
            let newId: string;

            // this strange logic because of type of `value`
            if (Array.isArray(value)) {
                newId = value[0]?.id || '';
            } else {
                newId = value?.id || '';
            }

            setFormValues((prevFormValues) => ({
                ...prevFormValues,
                [field.path]: newId,
            }));
            setFieldsTouched((prevFieldsTouched) => ({ ...prevFieldsTouched, [field.path]: true }));
        },
        [field.path, setFieldsTouched, setFormValues]
    );

    return (
        <PlainDataProvider items={items}>
            <DropdownEditor
                value={selectedItem}
                onChange={handleChange}
                listItem={field.path === localClearingSystemKey ? ClearingSystemListItem : undefined}
            />
        </PlainDataProvider>
    );
});

export default FieldSelect;
